<template>
  <div class="min-w-screen relative z-0 flex min-h-screen w-full items-center">
    <CookieBanner
      v-if="showCookieBanner === true"
      :class="[showCookieBanner ? 'opacity-100' : 'hidden opacity-0']"
      class="z-50 transition-opacity"
      @show-cookie-banner="showCookieBanner = $event"
    />
    <Toaster />

    <Suspense>
      <RouterView class="z-0" />
    </Suspense>
  </div>
</template>

<script lang="ts">
  import 'swiper/css/bundle';
  import 'swiper/css/pagination';
  import 'swiper/css/navigation';

  import { register } from 'swiper/element/bundle';
  import { defineComponent } from 'vue';

  import CookieBanner from '@/components/base/cookieBanner.component.vue';
  import Toaster from '@/components/ui/toast/Toaster.vue';

  export default defineComponent({
    name: 'App',
    components: {
      Toaster,
      CookieBanner,
    },

    data() {
      return {
        utms: '',
        isLoading: true,
        showCookieBanner: true,
      };
    },

    mounted() {
      register();
      if (this.$route.fullPath.includes('?')) {
        const fullUrl = this.$route.fullPath.split('?');
        this.$root.utms = '?' + fullUrl[1];
      }
      this.showCookieConsentBanner();
      const appDiv = document.getElementById('app');
      appDiv?.classList.add('loaded');
    },
    methods: {
      getCookie(nomeDoCookie: string): string {
        const cookies = document.cookie.split('; ').filter(Boolean);
        for (const cookie of cookies) {
          const eqIdx = cookie.indexOf('=');
          const cookieName = eqIdx >= 0 ? cookie.slice(0, eqIdx) : cookie;
          const cookieValue = eqIdx >= 0 ? cookie.slice(eqIdx + 1) : '';
          if (cookieName === nomeDoCookie) {
            return cookieValue;
          }
        }
        return '';
      },
      showCookieConsentBanner() {
        const showCookiePreferencesBanner = this.getCookie(
          'bextPro_showCookieBanner',
        );

        if (showCookiePreferencesBanner.length) {
          if (showCookiePreferencesBanner === 'false') {
            this.showCookieBanner = false;
          } else {
            this.showCookieBanner = true;
          }
        } else {
          this.showCookieBanner = true;
        }
      },
    },
  });
</script>
